import { DSNCUnsafeHtml } from 'shared-definitions/types'
import styleUtils from 'shared-components/styles/util.module.css'
import styleContent from 'shared-components/styles/content.module.css'
import clsx from 'clsx'
import { useScrollableLinksContainer } from 'shared-components/hooks/use-scrollbale-links-container'
import composeRefs from '@seznam/compose-react-refs'
import { useTooltipsContainer } from 'shared-components/hooks/use-tooltips-container'

interface NCUnsafeHtmlProps {
  data: DSNCUnsafeHtml
}

const NCUnsafeHtml: React.VFC<NCUnsafeHtmlProps> = ({ data }) => (
  <div
    ref={composeRefs(useScrollableLinksContainer(), useTooltipsContainer())}
    className={clsx(styleUtils.nc, styleContent.content)}
    dangerouslySetInnerHTML={{ __html: data.html }}
  />
)

export default NCUnsafeHtml
